import { render } from "./dynamic-form.vue?vue&type=template&id=b8c2267e&scoped=true&lang=true"
import script from "./dynamic-form.vue?vue&type=script&lang=js"
export * from "./dynamic-form.vue?vue&type=script&lang=js"

import "./dynamic-form.vue?vue&type=style&index=0&id=b8c2267e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c2267e"]])

export default __exports__